import * as FeatureFlagNames from '@/constants/featureFlags';
import ffDefaults from '@/constants/ffDefaults';
import type { FeatureFlags } from '@/constants/types';
import { createUseFeatureFlags } from '@montugroup/circuit-shared/hooks/featureFlags/createUseFeatureFlags';

/**
 * @deprecated 🚫 Prefer `useFeatureFlag` or `useFeatureFlagsSelector` with a selector instead.
 */
const useFeatureFlags = createUseFeatureFlags<FeatureFlags>({
  defaults: ffDefaults,
  flagKeys: Object.values(FeatureFlagNames),
});

export default useFeatureFlags;
